import styled, {css} from "styled-components";

interface IGroupFiltersListGroupItemTitleBoxProps {
    amount?: number;
}

export const GroupFiltersListGroupFilterTitleBox = styled.span<IGroupFiltersListGroupItemTitleBoxProps>`
  margin-left: 20px;
  font-size: 15px;
  ${({theme}) => theme.font.presets.medium};
  color: ${props => props.theme.colors.text};

  ${({amount}) => amount && amount > 0 && css`
    &:after {
      content: "(${amount})";
      margin-left: 10px;
    }
  `};
`;